module.exports = __webpack_public_path__ + "static/bamazon-216e6dd2d760dace3db17bbd668aa77a.jpg";